import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import {
  ContributorMatchServiceListDto,
  ContributorMatchServiceListResource,
  Permission,
  PermissionAction,
  SortObject,
} from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { contributorMatchServicePageRoute } from "../ContributorMatchServicePage/ContributorMatchServicePage";

export const ContributorMatchServiceTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  contributorMatchServices: ContributorMatchServiceListDto[];
  setContributorMatchServices: (contributorMatchServices: ContributorMatchServiceListDto[]) => void;
  resource: ContributorMatchServiceListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorMatchServiceListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorMatchServiceListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.contributorMatchServices.map((contributorMatchServiceItem) => (
            <TableRow
              key={contributorMatchServiceItem.id}
              onClick={() =>
                navigate(
                  contributorMatchServicePageRoute.getPath({
                    id: contributorMatchServiceItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{contributorMatchServiceItem.id}</TableCell>
              <TableCell>{contributorMatchServiceItem.name}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    color="primary"
                    onClick={() =>
                      navigate(
                        contributorMatchServicePageRoute.getPath({
                          id: contributorMatchServiceItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
